import React, { FC } from 'react'
import { PrintLayout } from 'components/Layout'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { parseToDate } from 'lib/helper'
import { format } from 'date-fns'
import ja from 'date-fns/locale/ja'
import { PrintOrderByBreadTemplate } from 'components/Templates'

const PrintOrderByBread: FC = () => {
  const pathname = useSelector((state: State) => state.router.location.pathname)
  const date = /\/order\/print\/[0-9]{8}\/product/.test(pathname)
    ? pathname.split('/order/print/')[1].split('/product')[0]
    : undefined
  const currentDate = date ? parseToDate(date) : new Date()
  const title = `${format(currentDate, 'M月d日(E)', { locale: ja })}のお渡し-商品別`

  return (
    <PrintLayout title={title}>
      <PrintOrderByBreadTemplate date={date} title={title} />
    </PrintLayout>
  )
}

export default PrintOrderByBread
